import { adminHttpClient } from '../../commons/adminHttpClient'

const triggerEarlyRunout = (
  planPeriodId: string,
  finalBenefitDate: string,
  runOutDays: number,
  sendEmail: boolean,
): Promise<any> => {
  return adminHttpClient.post('/csi/Companies/Benefit/TriggerEarlyRunout', {
    planPeriodId: planPeriodId,
    finalBenefitDate: finalBenefitDate,
    RunOutDays: runOutDays,
    SendEmail: sendEmail,
  })
}

export default triggerEarlyRunout
